(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-selector-1x2/assets/javascripts/betslip-selector.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-selector-1x2/assets/javascripts/betslip-selector.js');
"use strict";

const BetslipCouponType = svs.components.tipsen.engine.constants.BetslipCouponType;
const useBetslipContext = svs.components.tipsen.betslipComponents.useBetslipContext;
const _svs$components$tipse = svs.components.tipsen.betslipSelector1x2.betslips,
  Enkelrader = _svs$components$tipse.Enkelrader,
  ExternaSystemspel = _svs$components$tipse.ExternaSystemspel,
  RSystem = _svs$components$tipse.RSystem,
  Standard = _svs$components$tipse.Standard,
  USystem = _svs$components$tipse.USystem,
  Competition = _svs$components$tipse.Competition;
const Reducera = svs.components.tipsen.betslipComponents.betslips.Reducera;
const BetslipSelector = () => {
  const _useBetslipContext = useBetslipContext(),
    couponType = _useBetslipContext.couponType;
  let BetslipLocal;
  switch (couponType) {
    case BetslipCouponType.Standard:
      BetslipLocal = Standard;
      break;
    case BetslipCouponType.RSystem:
      BetslipLocal = RSystem;
      break;
    case BetslipCouponType.USystem:
      BetslipLocal = USystem;
      break;
    case BetslipCouponType.ReduceraFritt:
      BetslipLocal = Reducera;
      break;
    case BetslipCouponType.Enkelrader:
      BetslipLocal = Enkelrader;
      break;
    case BetslipCouponType.ExternaSystemspel:
      BetslipLocal = ExternaSystemspel;
      break;
    case BetslipCouponType.Competition:
      BetslipLocal = Competition;
      break;
    default:
      BetslipLocal = null;
      throw new Error("No betslip found for couponType: ".concat(couponType));
  }
  return React.createElement(BetslipLocal, null);
};
setGlobal('svs.components.tipsen.betslipSelector1x2.BetslipSelector', BetslipSelector);

 })(window);